export class LiteFilter {
  constructor({
    containerSelector,
    buttonSelector,
    itemToFilterSelector,
    activeButtonClass = `active`,
  }) {
    this.containerSelector = containerSelector;
    this.buttonSelector = buttonSelector;
    this.itemToFilterSelector = itemToFilterSelector;
    this.activeButtonClass = activeButtonClass;
    this.containerElement = document.querySelector(this.containerSelector);
    this.buttonsElements;
    this.elementsToFilter;
    this._activeButton;
    this.filteredElements;

    this._onButtonClick = this._onButtonClick.bind(this);
  }

  _getFilteredElements(filterTag) {
    return Array.from(this.elementsToFilter).filter((element) =>
      JSON.parse(element.dataset.tagsToFilter).includes(filterTag),
    );
  }

  _showFilteredElements(filterTag) {
    this.filteredElements.forEach((element) => (element.style.display = `none`));

    this.filteredElements = this._getFilteredElements(filterTag);
    this.filteredElements.forEach((element) => (element.style.display = ``));
  }

  _setActivityStatusBtn(button) {
    this._activeButton.classList.remove(this.activeButtonClass);

    this._activeButton = button;

    this._activeButton.classList.add(this.activeButtonClass);
  }

  _onButtonClick(evt) {
    const target = evt.currentTarget;
    const filterTag = target.dataset.filterTag;

    this._setActivityStatusBtn(target);
    this._showFilteredElements(filterTag);
  }

  init() {
    if (this.containerElement) {
      this.buttonsElements = this.containerElement.querySelectorAll(this.buttonSelector);
      this.elementsToFilter = this.containerElement.querySelectorAll(this.itemToFilterSelector);
      this._activeButton = Array.from(this.buttonsElements).find((button) =>
        button.classList.contains(this.activeButtonClass),
      );
      this.filteredElements = this.elementsToFilter;

      this.buttonsElements.forEach((buttonElement) => {
        buttonElement.addEventListener(`click`, this._onButtonClick);
      });
    }
  }
}
